module.exports = __webpack_public_path__ + "img/INTJ.3eddb418.png";